import fetch from 'isomorphic-fetch'
// import config from '~/config'

// The GraphQL link already sends X-RunX-Platform (src/index.js); these REST
// auth calls must send it too so the API can platform-gate (e.g. thai/mice
// skip Firebase user creation at /register).
const platformHeader = process.env.REACT_APP_PLATFORM
  ? { 'X-RunX-Platform': process.env.REACT_APP_PLATFORM }
  : {}

const registerUser = user =>
  fetch(`${process.env.REACT_APP_API_AUTH_URI}/register`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...platformHeader
    },
    body: JSON.stringify(user)
  }).then(res => res.json())

const loginUser = ({ email, password }) =>
  fetch(`${process.env.REACT_APP_API_AUTH_URI}/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...platformHeader
    },
    body: JSON.stringify({ email, password })
  }).then(res => res.json())

const logoutUser = () =>
  fetch(`${process.env.REACT_APP_API_AUTH_URI}/logout`, {
    credentials: 'include'
  }).then(res => res.json())

const getAuthUri = (strategy, { redirectTo = '' } = {}) => {
  let uri = `${process.env.REACT_APP_API_AUTH_URI}/${strategy}`
  if (redirectTo) {
    uri += `?redirectTo=${redirectTo}`
  }
  return uri
}

const auth = {
  registerUser,
  loginUser,
  logoutUser,
  getAuthUri
}

// export default auth
// export default { registerUser }
export { registerUser, loginUser, logoutUser, getAuthUri }
export default auth
